import { ModernEmailClient } from "@/components/email/ModernEmailClient";

const Email = () => {
  return (
    <div className="h-screen w-full bg-background text-foreground overflow-hidden">
      <ModernEmailClient />
    </div>
  );
};

export default Email;